'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _popupOpenSelector = require('../../../../components/popupPanel/popupOpenSelector');

var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);

var _selectedElementsSelector = require('../../../../element/selection/selectedElementsSelector');

var _elementSelector = require('../../../../element/elementSelector');

var _ColorToolIcon = require('./ColorToolIcon');

var _ColorToolIcon2 = _interopRequireDefault(_ColorToolIcon);

var _ColorPopup = require('./ColorPopup');

var _ColorPopup2 = _interopRequireDefault(_ColorPopup);

var _Tool = require('../../Tool');

var _Tool2 = _interopRequireDefault(_Tool);

var _popupActions = require('../../../../components/popupPanel/popupActions');

var _colorConstants = require('../../../../../common/colors/colorConstants');

require('./ColorTool.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants


// Components
var getSelectedColor = function getSelectedColor(selection, elements) {
    if (elements.get(selection.first())) {
        return elements.get(selection.first()).getIn(['content', 'color']);
    }

    return null;
};

// Actions


// Selectors
// Lib


var getSelectedElementType = function getSelectedElementType(selection, elements) {
    if (elements.get(selection.first())) {
        return elements.get(selection.first()).get('elementType');
    }

    return null;
};

var colorToolSelector = (0, _reselect.createSelector)(_elementSelector.getElements, _selectedElementsSelector.getSelectedElementIds, (0, _popupOpenSelector2.default)('color'), function (elements, selection, popupIsOpen) {
    return {
        elements: elements,
        selection: selection,
        popupIsOpen: popupIsOpen,
        selectedColor: getSelectedColor(selection, elements),
        selectedType: getSelectedElementType(selection, elements)
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        openColorPopup: function openColorPopup() {
            return dispatch((0, _popupActions.togglePopup)('color'));
        }
    };
};

var ColorTool = function ColorTool(props) {
    var openColorPopup = props.openColorPopup,
        selectedColor = props.selectedColor,
        selectedType = props.selectedType,
        popupIsOpen = props.popupIsOpen;


    return _react2.default.createElement(
        'div',
        { className: 'ColorTool' },
        _react2.default.createElement(
            _Tool2.default,
            { handleClick: openColorPopup, name: 'Color' },
            _react2.default.createElement(_ColorToolIcon2.default, { selectedType: selectedType, color: _colorConstants.COLORS[selectedColor], isActive: popupIsOpen })
        ),
        _react2.default.createElement(_ColorPopup2.default, props)
    );
};

ColorTool.propTypes = {
    openColorPopup: _propTypes2.default.func,
    selectedColor: _propTypes2.default.string,
    selectedType: _propTypes2.default.string,
    popupIsOpen: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(colorToolSelector, mapDispatchToProps)(ColorTool);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/colorTools/ColorTool.js
// module id = 2231
// module chunks = 0